import { render } from "./GestureSource.vue?vue&type=template&id=e81d7cee"
import script from "./GestureSource.vue?vue&type=script&lang=js"
export * from "./GestureSource.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__